module.exports = __webpack_public_path__ + "img/dock-leveller.3f335c49.svg";